import React, { useEffect, useState } from 'react'
import Card from '../../../Base/Components/Card/Card'
import { setTitlePage } from '../../../Base/Services/Config/ConfigService'
import { Button } from 'primereact/button'
import { getSesiones } from '../../../API/IT/Sesiones/SesionesRequests'
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid'

const SesionesScreen = () => {

  const [Sesiones, setSesiones] = useState([]);
  const [loading, setLoading] = useState(false);

  const getInfo = async () => {
    setLoading(true);
     const d = await getSesiones();
     console.log(d);
     setSesiones(d);
     setLoading(false);
  }

  const columns = [
    {
        header: 'idUser',
        field: 'idUser',
        className: 'Xsmall'
    },
    {
        header: 'Usuario',
        field: 'Usuario',
        className: 'small',
    },
    {
        header: 'UserName',
        field: 'UserName',
    },
    {
        header: 'Creada',
        field: 'Creada',
        Format: 'DateTime'
    },
    {
        header: 'Vencimiento',
        field: 'Vencimiento',
        Format: 'DateTime'
    },
    {
        header: 'IP',
        field: 'IP',
        Format: 'Right',
        className: 'small'
    },
    {
        header: 'Device',
        field: 'Device',
    },
    
  ];

  const table = {
    Columns: columns,
    Data: Sesiones,
    loading: loading,
  };

  useEffect(() => {
    setTitlePage('Sesiones');
    getInfo();
  }, [])

  return (
    <div>
      <Card
        titulo={<div className='botones'>
          <h3>Sesiones</h3>
          <Button  icon='pi pi-refresh' onClick={getInfo}/>
        </div>}
        contenido={<div className='p-4' style={{ height: '90vh' }}>
          <AgGrid table={table} />
        </div>}
      />
    </div>
  )
}

export default SesionesScreen